module.exports = {
      id: "facebook-bg-usage",
      viewBox: "0 0 24 24",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#facebook-bg",
      toString: function () {
        return this.url;
      }
    }